/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessOrdersToShipDto } from '../../models/process-orders-to-ship-dto';
import { ProcessOrdersToShipResponseDto } from '../../models/process-orders-to-ship-response-dto';

export interface MgmtOrdersToShipControllerProcess$Params {
      body: ProcessOrdersToShipDto
}

export function mgmtOrdersToShipControllerProcess(http: HttpClient, rootUrl: string, params: MgmtOrdersToShipControllerProcess$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessOrdersToShipResponseDto>> {
  const rb = new RequestBuilder(rootUrl, mgmtOrdersToShipControllerProcess.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessOrdersToShipResponseDto>;
    })
  );
}

mgmtOrdersToShipControllerProcess.PATH = '/api/mgmt-orders/to-ship/process';
